import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { factorColumn } from "Constants/TableColumns";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { read } from "Helpers/LocalStorage";
import { getFactorUnitList } from "Stores/actions";
import { Checkbox } from "@material-ui/core";
import { FACTOR_RESULT } from "Stores/actionTypes";
import Translator from "Languages/Utility/Translator";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";

function FactorTable({ parentLoading }) {
  const { factorData, factorPagination, factorResult, selectedProject } =
    useSelector((state) => ({
      factorData: state.factor.factorData,
      factorPagination: state.factor.factorPagination,
      factorResult: state.factor.factorResult,
      selectedProject: state.project.selectedProject,
    }));
  const dispatch = useDispatch();
  const [sizePerPage, setSizePerPage] = useState(factorPagination.Limit);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(factorPagination.Page);
  const [total, setTotal] = useState(1);
  const [tblData, setTblData] = useState([]);

  useEffect(() => {
    if (factorData) {
      setTblData(factorData);
      setTotal(factorPagination.Total);
      if (factorResult.CheckAll && factorData.length !== 0) {
        let ListUnitId = factorResult.ListUnitId;
        if (factorPagination.Page === 1) {
          ListUnitId = factorData.map((row) => { return row.Id });
        } else {
          factorData.map((row) => {
            ListUnitId.push(row.Id);
          });
        }
        dispatch({
          type: FACTOR_RESULT,
          factorResult: { ...factorResult, ListUnitId }
        });
      }
      setLoading(false);
    }
  }, [factorData, factorPagination, factorResult.CheckAll]);

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      try {
        setLoading(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdProject: selectedProject.Id,
          Limit: sizePerPage,
          Page: page,
        };
        await dispatch(getFactorUnitList(params));
        setCurrentPage(page);
        setSizePerPage(sizePerPage);
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    }
  };

  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    selected: factorResult.ListUnitId,
    onSelect: (row, isSelect) => {
      let list = factorResult.ListUnitId;
      if (isSelect) {
        list.push(row.Id);
      } else {
        list = list.filter((i) => i !== row.Id);
      }
      dispatch({
        type: FACTOR_RESULT,
        factorResult: { ...factorResult, ListUnitId: list, CheckAll: false },
      });
    },
    onSelectAll: (isSelect, rows) => {
      dispatch({
        type: FACTOR_RESULT,
        factorResult: {
          ...factorResult,
          CheckAll: !factorResult.CheckAll,
          ListUnitId: factorResult.CheckAll ? [] : factorResult.ListUnitId,
        },
      });
    },
    classes: "selection-row",
    selectionHeaderRenderer: ({ indeterminate, ...rest }) => (
      <Checkbox
        className="selectRadio"
        // ref={(input) => {
        //   console.log('input', input);
        //   if (input) input.indeterminate = indeterminate;
        // }}
        {...rest}
        checked={factorResult.CheckAll}
      />
    ),
    selectionRenderer: ({ checked, disabled }) => {
      return (
        <Checkbox
          className="selectRadio"
          color="default"
          checked={checked}
          disabled={disabled}
        />
      );
    },
  };

  return (
    <Fragment>
      <BackDropLoading loading={loading} />
      <RemoteTable
        keyField="Id"
        loading={loading || parentLoading}
        selectRow={selectRow}
        data={tblData}
        columns={factorColumn}
        page={currentPage}
        sizePerPage={sizePerPage}
        totalSize={total}
        onTableChange={onTableChange}
        title={<Translator id="Select_the_unit" noSpan />}
      />
    </Fragment>
  );
}

export default FactorTable;
